import React, {
    useState,
    useLayoutEffect,
    useCallback,
    useRef,
    useEffect,
} from 'react';
import areWeOnMobile from 'components/helpers/areWeOnMobile';
import {useTheme} from '@material-ui/core/styles';
import {noop} from 'components/helpers/funcTools';

const UIContext = React.createContext({
    actions: {
        showSnackbar: noop,
        closeSnackbar: noop,
    },
    data: {
        isMobile: false,
        snackbarText: null,
    }
});

const SNAKCBAR_VISIBLE_TIMEOUT = 3000; // 3 seconds;

export function UIContextProvider({children}) {
    const [isMobile, setIsMobile] = useState(areWeOnMobile());
    const [snackbarText, setSnackbarText] = useState(null);
    const snackbarHideTimer = useRef();
    const theme = useTheme();

    const handleResize = () => {
        setIsMobile(areWeOnMobile(theme.breakpoints.width('md')));
    };

    const handleShowSnackbar = useCallback((text) => {
        setSnackbarText(text);

        snackbarHideTimer.current = setTimeout(() => {
            setSnackbarText(null);
        }, SNAKCBAR_VISIBLE_TIMEOUT);
    }, [setSnackbarText]);

    const handleCloseSnackbar = useCallback(() => {
        setSnackbarText(null);
        clearTimeout(snackbarHideTimer.current);
    }, [setSnackbarText]);

    useLayoutEffect(() => {
        window.addEventListener('resize', _.throttle(handleResize, 1000));

        return () => window.removeEventListener('resize', _.throttle(handleResize, 1000));
    }, []);

    useEffect(() => {
        () => clearTimeout(snackbarHideTimer.current);
    }, [])

    return (
        <UIContext.Provider
            value={{
                actions: {
                    showSnackbar: handleShowSnackbar,
                    closeSnackbar: handleCloseSnackbar,
                },
                data: {
                    isMobile,
                    snackbarText,
                },
            }}
        >
            {children}
        </UIContext.Provider>
    );
}

export const withUiContext = (Component) =>
    class extends React.PureComponent {
        render() {
            return (
                <UIContext.Consumer>
                    {context => (
                        <Component
                            {...this.props}
                            ui={context}
                        />
                    )}
                </UIContext.Consumer>
            );
        }
    }

export default UIContext;



// WEBPACK FOOTER //
// ./src/sources/contexts/UiContext.jsx